import { useCallback, useLayoutEffect, useRef } from "react";

/**
 * Stable event handler — always calls the latest version of `fn`, never stale.
 * (Aproximación local a `useEffectEvent` de React: la identidad de la función
 * devuelta es estable, pero al invocarla ejecuta la última `fn` recibida.)
 *
 * `useEffectEvent` aún no está exportado de forma estable desde `react`
 * (React 19.1, el que usa la web). Este shim evita el import directo desde
 * `react` que falla en runtime con "useEffectEvent is not a function".
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useEffectEvent<T extends (...args: any[]) => any>(fn: T): T {
  const ref = useRef(fn);
  useLayoutEffect(() => {
    ref.current = fn;
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback((...args: Parameters<T>) => ref.current(...args), []) as T;
}
